'use strict';

export default function StickyContainer({
    isStickable = true,
    wrapClassName = 'sticky-wrapp',
    containerClassName = 'sticky',
    containerStickyClassName = 'is-sticky',
    offsetTop = 0,
    stickyPadding = 0,
    onChange,
    children})
{
    const wrapRef = React.useRef();
    const containerRef = React.useRef();
    const [isSticky, setIsSticky] = React.useState(false);
    const [fixedHeight, setFixedHeight] = React.useState(null);

    React.useEffect(() => {
        
        if (!isStickable) {
            setFixedHeight(null);
            setIsSticky(false);
        }

        if (isStickable && containerRef.current) {

            const $wrap = $(wrapRef.current)
            const $container = $(containerRef.current);
            
            let wrapTop = $wrap.offset().top - stickyPadding;
            const wrapHeight = $wrap.outerHeight() || 0;
            const containerHeight = $container.outerHeight() || 0;

            setFixedHeight(wrapHeight);

            function handleWindowLoad() {
                wrapTop = $container.offset().top - stickyPadding;
                handleWindowScroll()
            }
            function handleWindowScroll() {
                const scrollTop = $(this).scrollTop();
                if (scrollTop + offsetTop >= wrapTop && !isSticky) {
                    setIsSticky(true);
                    onChange && onChange({ isSticky: isSticky, stickyTop: wrapTop, wrapHeight, containerHeight });
                }
                if (scrollTop + offsetTop < wrapTop && isSticky) {
                    setIsSticky(false);
                    onChange && onChange({ isSticky: isSticky, stickyTop: wrapTop, wrapHeight, containerHeight });
                }
            }

            $(window).on('scroll', handleWindowScroll);
            $(window).on('load', handleWindowLoad);
            
            handleWindowScroll.call(window)

            return () => {
                $(window).off('scroll', handleWindowScroll);
                $(window).off('load', handleWindowLoad);
            }
        }
    }, [isStickable, setIsSticky, isSticky, offsetTop]);
    
    return <div ref={wrapRef} className={wrapClassName} style={{
        height: isSticky ? fixedHeight : undefined,
    }}>
        <div ref={containerRef} 
             className={cn(containerClassName, isSticky && containerStickyClassName)} 
             style={{
                 top: isSticky ? offsetTop : undefined,
                 maxHeight: window.innerHeight - offsetTop - stickyPadding * 2
             }}>
            {children}
        </div>
    </div>
}